import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ConstructionInfo extends Component {

  render() {

    let CustomClass = this.props.customClass ? this.props.customClass : ''

    let publicUrl = process.env.PUBLIC_URL + '/'

    return <div className={"ltn__apartments-plan-area pt-115--- pb-70 " + CustomClass}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              {/* <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">Apartment Sketch</h6> */}
              <h1 className="section-title">Individual House Construction</h1>
            </div>
            <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
              <div className="col-lg-6">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <img src={publicUrl + "assets/img/projects/Krishna Nagar/img1.jpg"} alt="#" />
                  </div>
                  <div className="search-by-place-info">
                    <h6>Navallur</h6>
                    <h4>Krishna Nagar</h4>
                    <div className="search-by-place-btn">
                      <Link to="/construction-01">View Projects <i className="flaticon-right-arrow" /></Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="ltn__search-by-place-item">
                  <div className="search-by-place-img">
                    <img src={publicUrl + "assets/img/projects/Ganesh Nagar/img2.jpg"} alt="#" />
                  </div>
                  <div className="search-by-place-info">
                    <h6>Malai Pattu</h6>
                    <h4>Ganesh Nagar</h4>
                    <div className="search-by-place-btn">
                      <Link to="/construction-02">View Projects <i className="flaticon-right-arrow" /></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export default ConstructionInfo